import React, { useState } from 'react';
import { Box } from '@mui/material';

import { PropertyTextInput } from '@paragon/client-tools';
import { ProductionGroup } from '@paragon/contract-library';

const initialProjectId = '';
const initialBuildingInstance = '';
const initialLevel = '';

export type SettableProductionGroupProperties = Pick<
  ProductionGroup,
  'projectId' | 'projectShortName' | 'buildingType' | 'buildingInstance' | 'level'
>;

interface ProductionGroupPropertiesProps {
  readonly productionGroupProperties: SettableProductionGroupProperties;
  readonly submit: (updatedProperties: SettableProductionGroupProperties) => void;
}

export function getProductionGroupPropertiesAreValid(productionGroupProperties: SettableProductionGroupProperties) {
  return (
    productionGroupProperties.level.trim().length > 0 &&
    productionGroupProperties.buildingInstance.trim().length > 0 &&
    productionGroupProperties.buildingType.trim().length > 0 &&
    productionGroupProperties.projectShortName.trim().length > 0 &&
    productionGroupProperties.projectId.trim().length > 0
  );
}

export function ProductionGroupProperties(props: ProductionGroupPropertiesProps) {
  const { productionGroupProperties, submit } = props;

  const [projectIdError, setProjectIdError] = useState<boolean>(false);
  const [projectShortNameError, setProjectShortNameError] = useState<boolean>(false);
  const [buildingTypeError, setBuildingTypeError] = useState<boolean>(false);
  const [buildingInstanceError, setBuildingInstanceError] = useState<boolean>(false);
  const [levelError, setLevelError] = useState<boolean>(false);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <PropertyTextInput
        property="Project ID"
        value={productionGroupProperties.projectId ?? initialProjectId}
        error={projectIdError}
        submit={(updatedProjectId) => {
          const updatedProjectIdTrimmed = updatedProjectId.trim();
          setProjectIdError(updatedProjectIdTrimmed.length === 0);
          submit({ ...productionGroupProperties, projectId: updatedProjectIdTrimmed });
        }}
      />
      <PropertyTextInput
        property="Project Short Name"
        value={productionGroupProperties.projectShortName}
        error={projectShortNameError}
        submit={(updatedProjectShortName) => {
          const updatedProjectShortNameTrimmed = updatedProjectShortName.trim();
          setProjectShortNameError(updatedProjectShortNameTrimmed.length === 0);
          submit({ ...productionGroupProperties, projectShortName: updatedProjectShortNameTrimmed });
        }}
      />
      <PropertyTextInput
        property="Building Type"
        value={productionGroupProperties.buildingType}
        error={buildingTypeError}
        submit={(updatedBuildingType) => {
          const updatedBuildingTypeTrimmed = updatedBuildingType.trim();
          setBuildingTypeError(updatedBuildingTypeTrimmed.length === 0);
          submit({ ...productionGroupProperties, buildingType: updatedBuildingTypeTrimmed });
        }}
      />
      <PropertyTextInput
        property="Building Instance"
        value={productionGroupProperties.buildingInstance ?? initialBuildingInstance}
        error={buildingInstanceError}
        submit={(updatedBuildingInstance) => {
          const updatedBuildingInstanceTrimmed = updatedBuildingInstance.trim();
          setBuildingInstanceError(updatedBuildingInstanceTrimmed.length === 0);
          submit({ ...productionGroupProperties, buildingInstance: updatedBuildingInstanceTrimmed });
        }}
      />
      <PropertyTextInput
        property="Level"
        value={productionGroupProperties.level ?? initialLevel}
        error={levelError}
        submit={(updatedLevel) => {
          const updatedLevelTrimmed = updatedLevel.trim();
          setLevelError(updatedLevelTrimmed.length === 0);
          submit({ ...productionGroupProperties, level: updatedLevelTrimmed });
        }}
      />
    </Box>
  );
}
